import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/HR';

export const statements: DeepPartial<StatementsConfig> = {
    specificMinDate: '01.01.1997',
    modes: {
        electronic: 'ONLY_ELECTRONIC',
        postal: 'PAPER',
    },
    tableColumns: {
        DEFAULT: ['DELIVERY_CONTACT', 'TIMESPAN', 'FORMAT'],
        CREDIT: ['PERIOD', 'HR_DUE_DATE', 'INVOICE_TOTAL', 'HR_MINIMUM_AMOUNT', 'DOWNLOAD'],
    },
    isEmailInputVisible: true,
    deliveryChange,
    addAccessTokenToDownloadBody: true,
};
